import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const eduCoursesApi = createApi({
  reducerPath: 'eduCoursesApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  tagTypes: ['EduCourses'],
  endpoints: (builder) => ({
    getEduCourses: builder.query({
      query: () => ({
        url: urls.eduCourses,
        method: 'GET',
      }),
      providesTags: ['EduCourses'],
    }),
    getEduCourse: builder.query({
      query: (id) => ({
        url: urls.eduCoursesDetail(id),
        method: 'GET',
      }),
    }),
    getEduLecturers: builder.query({
      query: () => ({
        url: urls.eduLecturers,
        method: 'GET',
      }),
    }),
    saveEduCourse: builder.mutation({
      query: (req) => {
        if (req.id) {
          return {
            url: urls.eduCoursesDetail(req.id),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: urls.eduCourses,
            method: 'POST',
            data: req.body,
          };
        }
      },
      invalidatesTags: ['EduCourses'],
    }),
    deleteEduCourse: builder.mutation({
      query: (id) => ({
        url: urls.eduCoursesDetail(id),
        method: 'DELETE',
      }),
      invalidatesTags: ['EduCourses'],
    }),
    getEduCoursesForPublic: builder.query({
      query: () => ({
        url: `${urls.eduPublicCourses}`,
        method: 'GET',
      }),
    }),
    getEduCourseDetailForPublic: builder.query({
      query: (id) => ({
        url: `${urls.eduPublicCoursesDetail(id)}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetEduCoursesQuery,
  useGetEduCourseQuery,
  useGetEduLecturersQuery,
  useSaveEduCourseMutation,
  useDeleteEduCourseMutation,
  useGetEduCourseWithActiveDatesDetailQuery,
  useGetEduCoursesForPublicQuery,
  useGetEduCourseDetailForPublicQuery,
} = eduCoursesApi;
